import { render, staticRenderFns } from "./verify-otp.vue?vue&type=template&id=4ddaeda0&scoped=true"
import script from "./verify-otp.vue?vue&type=script&lang=js"
export * from "./verify-otp.vue?vue&type=script&lang=js"
import style0 from "./verify-otp.vue?vue&type=style&index=0&id=4ddaeda0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ddaeda0",
  null
  
)

export default component.exports